import { getNeutralVariant, getSoftVariant, getStrongVariant } from './variants';
/**
 * Add all variants to provided theme as elements of the theme's scheme property.
 * Any existing schemes will be overwritten.
 *
 * @export
 * @param {ITheme} theme Theme for which variants will be added.
 */
export function addVariants(theme) {
    theme.schemes = {
        strong: getStrongVariant(theme),
        soft: getSoftVariant(theme),
        neutral: getNeutralVariant(theme),
    };
}
//# sourceMappingURL=utilities.js.map